import type { NavigationItem } from '../types/navigation'

export const navigationItems: NavigationItem[] = [
  { labelKey: 'navigation.home', path: '/' },
  { labelKey: 'navigation.projects', path: '/projects' },
  { labelKey: 'navigation.skills', path: '/skills' },
  { labelKey: 'navigation.about', path: '/about' },
  // { labelKey: 'navigation.playground', path: '/playground' },
  { labelKey: 'navigation.contact', path: '/contact' },
]
